import { cyan, lime } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para meios de julgamento de sessão de julgamento.
 *
 * @readonly
 * @enum {Object}
 */
export const MEIO_JULGAMENTO_SESSAO = {
    VIRTUAL: {
        id: 'VIRTUAL',
        descricao: 'Exclusivamente virtual',
        descricaoCurta: 'Virtual',
        codigo: 'VIRTUAL',
        cor: lime[700]
    },
    SALA_DE_SESSAO_COM_PERIODO_VIRTUAL: {
        id: 'SALA_DE_SESSAO_COM_PERIODO_VIRTUAL',
        descricao: `Em sala de sessão vinculada à sessão virtual`,
        descricaoCurta: `Em sala de sessão`,
        codigo: 'PRESENCIAL',
        cor: cyan[800]
    },
    SALA_DE_SESSAO: {
        id: 'SALA_DE_SESSAO',
        descricao: `Exclusivamente em sala de sessão`,
        descricaoCurta: 'Exclusivamente em sala de sessão',
        codigo: 'EXCLUSIVAMENTE_PRESENCIAL',
        cor: cyan[800]
    }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de meios de julgamento de sessão de julgamento.
 * @readonly
 */
export default class MeioJulgamentoSessao {
    static idDescricaoBase = new SituacaoIdDescricaoBase(MEIO_JULGAMENTO_SESSAO);

    static getDescricao(id) {
        return MeioJulgamentoSessao.idDescricaoBase.getDescricao(id);
    }

    static getCodigo(id) {
        return MeioJulgamentoSessao.idDescricaoBase.getValorPropriedade(id, 'codigo');
    }

    static getDescricaoCurta(id) {
        return MeioJulgamentoSessao.idDescricaoBase.getValorPropriedade(id, 'descricaoCurta');
    }

    static getCor(id) {
        return MeioJulgamentoSessao.idDescricaoBase.getValorPropriedade(id, 'cor');
    }

    static getItemByCodigo(codigo) {
        return MeioJulgamentoSessao.idDescricaoBase.getObjectByProperty('codigo', codigo);
    }

    static getIdByCodigo(codigo) {
        const obj = MeioJulgamentoSessao.getItemByCodigo(codigo);
        return obj ? obj.id : '';
    }

    static getDescricaoByCodigo(codigo) {
        return MeioJulgamentoSessao.getDescricao(MeioJulgamentoSessao.getIdByCodigo(codigo));
    }

    static getDescricaoCurtaByCodigo(codigo) {
        return MeioJulgamentoSessao.getDescricaoCurta(MeioJulgamentoSessao.getIdByCodigo(codigo));
    }

    static getCorByCodigo(codigo) {
        return MeioJulgamentoSessao.getCor(MeioJulgamentoSessao.getIdByCodigo(codigo));
    }
}
